import React from 'react';
import { Check } from 'lucide-react';
import Reveal from './Reveal';
import { photos } from '../photos';

export default function Nutrition({ t }) {
  const n = t.nutrition;

  return (
    <section id="nutrition" className="scroll-mt-24 bg-sand/50 py-20 lg:py-28">
      <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-10 grid lg:grid-cols-2 gap-10 lg:gap-16 items-center">
        <Reveal>
          <div className="relative min-h-[460px] bg-pine overflow-hidden">
            <img src={photos.meal} alt={t.media.meal} className="absolute inset-0 w-full h-full object-cover" />
            <div className="absolute inset-0 bg-gradient-to-tr from-ink/70 via-transparent to-transparent" />
            <div className="absolute left-5 right-5 bottom-5 bg-cream p-5 shadow-lift">
              <p className="text-[11px] font-bold uppercase tracking-[0.2em] text-stone">{n.dailyGoal}</p>
              <div className="mt-4 flex flex-col gap-3">
                {n.macros.map((m) => (
                  <div key={m.label}>
                    <div className="flex justify-between text-xs font-bold uppercase tracking-wider mb-1">
                      <span>{m.label}</span>
                      <span>{m.pct}%</span>
                    </div>
                    <div className="h-2 bg-sand">
                      <div className="h-full bg-ember" style={{ width: `${m.pct}%` }} />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </Reveal>

        <Reveal delay={80}>
          <p className="font-display text-xs tracking-[0.32em] uppercase text-ember">04 — {n.kicker}</p>
          <h2 className="mt-4 font-display uppercase text-4xl sm:text-5xl lg:text-6xl leading-[0.92]">
            {n.title}
          </h2>
          <p className="mt-5 text-lg text-stone leading-relaxed">{n.sub}</p>
          <ul className="mt-8 flex flex-col gap-3">
            {n.features.map((f) => (
              <li key={f} className="flex items-center gap-3 font-semibold">
                <span className="w-6 h-6 bg-ember text-ink flex items-center justify-center shrink-0">
                  <Check size={14} strokeWidth={3} />
                </span>
                {f}
              </li>
            ))}
          </ul>

          <div className="mt-8 border border-ink/15 bg-cream p-6">
            <h3 className="font-display text-2xl uppercase">{n.calculatorTitle}</h3>
            <p className="mt-2 text-sm text-stone">{n.calculatorSub}</p>
            <div className="mt-4 flex flex-wrap gap-2">
              {n.calculatorInputs.map((input) => (
                <span key={input} className="px-3 py-1.5 bg-sand text-xs font-bold uppercase tracking-wider">
                  {input}
                </span>
              ))}
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
